import { Link } from 'gatsby';
import * as React from 'react';
import PropTypes from 'prop-types';

export default function SubNavItem(props) {
  return (
    <Link
      to={props.to}
      className="w-full flex items-center gap-x-2 p-3 bg-white rounded-lg shadow-[0_0_10px_0_rgba(0,0,0,0.1)]"
    >
      {props.children}
    </Link>
  );
}

SubNavItem.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
};
